import { Grid } from '@material-ui/core';
import { XMLParser } from 'fast-xml-parser';
import React from 'react';
import ReactJson from 'react-json-view';
import XMLViewer from 'react-xml-viewer';
import ButtonNav from './buttonNav';
import './asyncXml.css';

const tabs = [
    'XML_AS_JSON',
    'XML'
];

function getTabName(tab) {
    switch (tab) {
        case 'XML_AS_JSON':
            return 'JSON';
        case 'XML':
            return 'Original XML';
        default:
            return undefined;
    }
}

export default function AsyncXmlAndJson(props) {
    const {
        xml,
        json,
        basic
    } = props;

    const [tab, setTab] = React.useState('XML_AS_JSON');

    const display = React.useMemo(() => {
        const {
            type,
            data
        } = xml;
        if (type !== 'SUCCEEDED') {
            return '';
        }
        if (basic) {
            return <div>{data}</div>;
        }
        if (tab === 'XML') {
            return <XMLViewer xml={data} collapsible theme={{ overflowBreak: true }} />;
        }
        const parser = new XMLParser({ ignoreAttributes: false, attributeNamePrefix: '' });
        const parsed = parser.parse(data);
        return <ReactJson src={parsed} />;
    }, [tab, xml]);

    const tryParse = (data) => {
        try {
            const result = JSON.parse(data);
            return result;
        } catch (error) {
            return {};
        }
    };

    const buttons = React.useMemo(() => (basic
        ? undefined
        : (
            <Grid container columns={11}>
                <Grid item xs={1} />
                <Grid item xs={10} style={{ paddingRight: '0.5rem' }}>
                    <ButtonNav tabs={tabs} tab={tab} getTabName={getTabName} setTab={setTab} />
                </Grid>
            </Grid>
        )), [basic, tabs, tab]);

    return (
        <>
            {buttons}
            <Grid container columns={11}>
                <Grid item xs={1} />
                <Grid item xs={5} style={{ paddingRight: '0.5rem' }}>
                    <div className="async-xml">
                        {xml.type === 'SUCCEEDED' ? display : undefined}
                    </div>
                </Grid>
                <Grid item xs={5} style={{ paddingRight: '0.5rem' }}>
                    <div className="async-xml">
                        {json.type === 'SUCCEEDED' ? <ReactJson src={tryParse(json?.data)} /> : undefined}
                    </div>
                </Grid>
            </Grid>
        </>
    );
}
